import { text } from '@modules/sign-up/text';
import type { FormEvent } from 'react';
import type { SignUpFormCopy } from './models';
import { text as featureText } from './text_business_logic';

export type { SignUpFormCopy } from './models';

export function getSignUpFormCopy(isSubmitting: boolean): SignUpFormCopy {
  return featureText.signUpFormCopy(isSubmitting);
}

export function getSignUpErrorMessage(error: Error): string {
  return error.message.includes('Invalid password') ? text.invalidPassword : text.error;
}

export function createSignUpFormSubmitHandler(onSubmit: () => void) {
  return (event: FormEvent) => {
    event.preventDefault();
    onSubmit();
  };
}
